/**
 * Helpers for Strapi media used with `next/image`.
 *
 * Next.js 16 blocks the image optimizer from fetching private IPs
 * (`127.0.0.1`, `localhost`, RFC1918). In local dev every `/_next/image`
 * request for Strapi uploads returns 400 and Lighthouse reports NO_LCP.
 * Production uses a public hostname (`admin.proslava.ba`) and is unaffected.
 */

const LOCAL_HOSTNAMES = new Set([
  'localhost',
  '127.0.0.1',
  '0.0.0.0',
  '[::1]',
])

function isPrivateIpv4(hostname: string): boolean {
  if (/^10\./.test(hostname)) return true
  if (/^192\.168\./.test(hostname)) return true
  if (/^172\.(1[6-9]|2\d|3[01])\./.test(hostname)) return true
  return false
}

/** True when the browser/optimizer must load the file directly (no `/_next/image`). */
export function shouldBypassImageOptimizer(src: string): boolean {
  if (!src || src.startsWith('/')) return false
  try {
    const u = new URL(src)
    if (LOCAL_HOSTNAMES.has(u.hostname)) return true
    if (isPrivateIpv4(u.hostname)) return true
    return false
  } catch {
    return false
  }
}
